(function(){
    'use strict';
    angular.module('app').controller('DriverGroupDetailsController', DriverGroupDetailsController);

    DriverGroupDetailsController.$inject = [
        '$scope',
        'FleetService',
        'ClientService',
        '$routeParams',
        '$location',
        '$timeout',
        'toastr',
        'FleetDriversTableService',
        'ConfirmationModalFactory',
        'ViewChangeNotificationFactory',
        'hasDuplicate',
        '$q',
        '$rootScope',
        '$window'
    ];

    function DriverGroupDetailsController(
        $scope,
        FleetService,
        ClientService,
        $routeParams,
        $location,
        $timeout,
        toastr,
        FleetDriversTableService,
        ConfirmationModalFactory,
        ViewChangeNotificationFactory,
        hasDuplicate,
        $q,
        $rootScope,
        $window
    ) {
        const vm = this;
        const viewConfirmation = new ConfirmationModalFactory({}, {
            message: 'messages.warning.viewChange.MESSAGE',
            code: 'messages.warning.viewChange.CODE',
        });
        const toInactiveConf = new ConfirmationModalFactory({},{
            message: 'messages.warning.statusChange.MESSAGE.TO_DRIVER_GROUP_INACTIVE',
            code: 'messages.warning.statusChange.CODE'
        });

        const toActiveConf = new ConfirmationModalFactory({},{
            message: 'messages.warning.statusChange.MESSAGE.TO_DRIVER_GROUP_ACTIVE',
            code: 'messages.warning.statusChange.CODE'
        });
        const onRouteChange = $scope.$on('$routeChangeStart', function(event, next) {
            if(!vm.isViewMode && isChanged(vm.driverGroup, vm.driverGroupRaw)){
                viewConfirmation.getInstance().result.then(function (cond) {
                    if (cond) {
                        onRouteChange();
                        let nextRoute = next.$$route.originalPath;
                        if( _.contains(next.$$route.originalPath, ':') ){
                            nextRoute = nextRoute.split(':')[0];
                        }
                        $location.path(nextRoute);
                    }
                });
                event.preventDefault();
            }
        });
        const deleteConf = new ConfirmationModalFactory({},{
            message: 'messages.warning.statusChange.MESSAGE.DELETE_RECORD',
            code: 'messages.warning.statusChange.CODE'
        });
        vm.driverGroupId = $routeParams.id;
        vm.driverGroup = {
            company: $rootScope.GlobalProfile.company
        };
        vm.driverGroupRaw = angular.copy(vm.driverGroup);
        vm.isViewMode = false;
        vm.fleetDriversTableService = null;
        vm.saveInProgress = false;

        vm.isUnique = isUnique;
        vm.saveDetails = saveDetails;
        vm.changeStatus = changeStatus;
        vm.searchForCompanies = searchForCompanies;
        vm.deleteDriverGroup = deleteDriverGroup;
        vm.gotoPreviousPage = gotoPreviousPage;
        (()=>{
            if($routeParams.id) {
                vm.isFetching = true;
                FleetService.DriverGroups.get(vm.driverGroupId, function(result) {
                    const group = result;
                    getCompanyDetails(result.companyId).then(data=>{
                        group.company = data;
                    }).finally(()=>{
                        vm.isFetching = false;
                        getDriverGroupDrivers(group.id);
                        vm.driverGroup = angular.copy(group);
                        vm.driverGroupRaw = angular.copy(group);
                    });
                }, function() {

                });
            }
        })();

        function searchForCompanies(select) {
            vm.companies =  [];
            if(!select.open){
                return false;
            }
            vm.searchingForCompany = true;
            ClientService.Company.getAll(
                function(data) {
                    vm.companies = data.content;
                    vm.searchingForCompany = false;
                }, function(err) {
                    vm.searchingForCompany = false;
                }, {
                    size:20,active: true, name: select.search
                });
        }

        function getCompanyDetails(id) {
            const defer = $q.defer();
            if(!id){
                $timeout(()=>{
                    defer.resolve($rootScope.GlobalProfile.company);
                });
                return defer.promise;
            }
            ClientService.Company.get(id, function(data) {
                defer.resolve(data)
            }, function(err) {
                defer.resolve($rootScope.GlobalProfile.company);
            });

            return defer.promise;
        }

        function getDriverGroupDrivers(driverGroupId) {
            vm.fleetDriversTableService = new FleetDriversTableService({exclude: ['driverGroup'], filter: {
                    driverGroupId
                }}).tableData;
        }

        function changeStatus(evt) {
            evt.preventDefault();
            if(vm.driverGroup.active){
                vm.driverGroup.active = false;
                toActiveConf.getInstance().result.then(function (cond) {
                    if(cond) vm.driverGroup.active = true;
                });
                return false;
            }
            vm.driverGroup.active = true;
            toInactiveConf.getInstance().result.then(function (cond) {
                if(cond) vm.driverGroup.active = false;
            });
        }

        function cleanPayload(driverGroup) {
            const {groupId, company, description, totalDrivers, name, active} = driverGroup;
            return {groupId, companyId: company.id, company: company.id, description, totalDrivers, name, active};
        }

        function isChanged(o, n) {
            return !angular.equals(cleanPayload(o), cleanPayload(n));
        }

        function isUnique(model) {
            vm.checkingDups = true;
            hasDuplicate({
                serviceCallback: FleetService.DriverGroups.getAll,
                callbackFormat: ['success', 'error', 'filter'],
                findBy: 'content',
                compareWith: model,
                compareBy: 'groupId',
                raw: angular.getObjVal(vm, 'driverGroupRaw.groupId'),
                filters: {
                    size: 1,
                    groupId: model
                }
            }).then(res => {
                vm.idError = res ? 'Driver group name is already taken' : null;
                vm.checkingDups = false;
            }).catch(err => {
                vm.checkingDups = false;
            });
        }

        function saveDetails(form) {
            form.$setSubmitted();
            if(form.$invalid){
                return false;
            }
            vm.saveInProgress = true;
            if($routeParams.id){
                FleetService.DriverGroups.update(vm.driverGroupId, cleanPayload(vm.driverGroup), result=>{
                    vm.saveInProgress = false;
                    toastr.success('Data successfully updated');
                    vm.driverGroup = angular.copy(result);
                    vm.driverGroupRaw = angular.copy(result);
                }, err=>{
                    vm.saveInProgress = false;
                    toastr.error(err.message);
                })
            }else{
                FleetService.DriverGroups.create(cleanPayload(vm.driverGroup), result=>{
                    onRouteChange();
                    $location.path('/fleets/driver-groups/details/' + result.id);
                    toastr.success('Data successfully created');
                }, err=>{
                    vm.saveInProgress = false;
                    toastr.error(err.message);
                })
            }
        }

        function deleteDriverGroup(driverGroup) {
            deleteConf.getInstance().result.then(cond=>{
                if(cond){
                    FleetService.DriverGroups.delete(driverGroup.id, data=>{
                        toastr.success('Driver Group successfully deleted');
                        onRouteChange();
                        $location.path('/fleets/driver-groups');
                    }, err=>{
                        toastr.error('Unable to do request. Please try again later', err.message);
                    })
                }
            });
        }

        function gotoPreviousPage(){
            $window.history.back();
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/fleets/DriverGroupDetailsController.js